module.exports = __webpack_public_path__ + "img/on_mobile_booking.ec9bc498.png";